import { DataSourceResponse } from "@/modules/brokers/models/DataSourceResponse";
import { CreateNoteRequest, EditNoteRequest, GetNotesRequest, Note } from "../models/Note";
import { AxiosResponse } from "axios";
import { AppResponse } from "@/modules/core/interfaces/appResponse";
import AuthorizedApiClient from "@/modules/auth/models/authorizedApiClient";
import { sortNotesNewestFirst } from "../utils/noteSort";

export class NoteApi {
    public async fetch(req: GetNotesRequest): Promise<Note[]> {
        const response: AxiosResponse<AppResponse<any[]>> =
            await AuthorizedApiClient.post('/note/getNotes', req);

        if (response.status) {
            const apiResult: AppResponse<any[]> = response.data;

            if (apiResult.success) {
                const noteModels = (apiResult.data || []).map((notePayload: any) => new Note(notePayload));
                return sortNotesNewestFirst(noteModels);
            } else {
                return [];
            }
        } else {
            return [];
        }
    }
    
    public async update(req: EditNoteRequest): Promise<Note | null> {
        const response: AxiosResponse<AppResponse<Note>> = 
            await AuthorizedApiClient.post('/note/update', req);

        if (response.status) {
            const apiResult: AppResponse<Note> = response.data;

            if (apiResult.success) {
                return apiResult.data;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    public async create(req: CreateNoteRequest): Promise<Note | null> {
        const response: AxiosResponse<AppResponse<Note>> = 
            await AuthorizedApiClient.post('/note', req);

        if (response.status) {
            const apiResult: AppResponse<Note> = response.data;

            if (apiResult.success) {
                return apiResult.data;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    public async delete(noteId: number): Promise<AppResponse<any> | null> {
        const resp = await AuthorizedApiClient.delete(`/note/delete/${noteId}`);

        if (resp.status) {
            return resp.data;
        } else {
            return null
        }
    }
}